import { UseQueryOptions } from 'react-query';
import { CuredApiPaths } from 'models/enums';
import useQuery from 'hooks/useQuery';
import QueryKeys from './keys';

const useDynamicContentCategories = (reactQueryOptions?: UseQueryOptions<string[], Error>) =>
    useQuery<string[]>(
        QueryKeys.DYNAMIC_CONTENT_CATEGORIES,
        CuredApiPaths.DYNAMIC_CONTENT_CATEGORIES,
        reactQueryOptions
    );

export default useDynamicContentCategories;
